import React from "react";
import { Link } from "react-router-dom";

import { Container, Box, Button } from '@mui/material';

import { useTheme } from '@mui/material/styles'

function Landing() {
  const theme = useTheme();
  const image = theme.palette.mode === 'dark' ? './juvalfri/logo_v.svg' : './juvalfri/logo_v-light.svg'

  return (
    <Container maxWidth='lg' style={{ marginTop: '48px' }}>
      <Box style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <img src={image} alt='logo' style={{ width: "25%" }} className='mb-4'></img>
        <hr style={{color: '#888', width: '100%', margin: '48px 0px'}}/>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Button variant="outlined" color="secondary" size="large">Iniciar Sesión &nbsp; <i className="fad fa-sign-in"></i></Button>
        </Link>
      </Box>
    </Container>
  );
}

export default Landing;